import { Component } from '@angular/core';

@Component({
  selector: 'app-bam-queries',
  templateUrl: './bam-queries.component.html',
  styleUrls: ['./bam-queries.component.scss']
})
export class BamQueriesComponent {
  queryId = 1;
}
